import React from 'react';
import Layout from 'layout/Layout';
import NotFound from 'components/NotFound';

const Error404Page: React.FC = () => {
  const pageTitle = 'web予約';

  return (
    <Layout pageTitle={pageTitle}>
      <NotFound message={'URLが間違っています。'}></NotFound>
    </Layout>
  );
};
export default Error404Page;
